module.exports = __webpack_public_path__ + "static/media/AtlasGrotesk-Light.fdeebe5f.otf";